import React, { Component } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { connect } from "react-redux";
import dot1 from "../../assets/images/png/MaskGroup101.png";

const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
  };
};

class BiomarkerDrugDiscoveryLanding extends Component {
  getStartedClicked = (id) => {
    if (id === "biomarker") {
      this.props?.history?.push({ pathname: '/app/bioMarker' });
    } else if (id === "network") {
      this.props?.history?.push({ pathname: '/app/discover/myProject' });
    } else if (id === "compound") {
      this.props?.history?.push({ pathname: '/app/discover/discover&Repurposing' });
    } else if (id === "seer") {
      this.props?.history?.push({ pathname: '/app/populationProjection' });
    }
  };

  render() {
    const cardData = [
      {
        id: "biomarker",
        heading: "Biomarker Browser",
        description:
          "A Web Portal for AI-based Comprehensive Discovery of Cancer Biomarkers.",
      },
      {
        id: "network",
        heading: "Network-Based Biomarkers and Drug Discovery",
        description:
          "Leverage network topology to uncover novel biomarkers and drug candidates. Visualize complex biological interactions and pathways.",
      },
      {
        id: "compound",
        heading: "Compound Evaluation",
        description:
          "In-vitro IC50 and EC50 evaluation in 86 human non-small cell lung cancer cell lines from PRISM repurposing secondary screen.",
      },
      {
        id: "seer",
        heading: "SEER Population Projection",
        description:
          "User Uploaded Data Population Projection with SEER.",
      },
    ];

    return (
      <div className="landing-main" style={{ height: "auto", minHeight: "calc(100vh - 15vh)", overflowY: "auto" }}>
        <div className="landing-top">
          <div className="landing-left">
            <img src={dot1} alt="Decoration" />
          </div>
          <div className="landing-content">
            <div className="heading-landing">Biomarker and Drug Discovery</div>
            <div className="heading-description">
              <div className="description-inner">
                Cloud Software Solution for Cancer Biomarker Discovery and Drug Development
              </div>
            </div>
          </div>
        </div>

        <div className="nav-cards-container">
          {cardData.map((card, index) => (
            <div className="nav-cards" key={index}>
              <div className="card-heading">{card.heading}</div>
              <div className="card-description">{card.description}</div>
              <div className="card-bottom">
                {card.underProgress ? (
                  <>
                    <span
                      id={`${card.id}Nav`}
                      className="w-100 get-started-button"
                      style={{
                        fontSize: "1rem",
                        display: "inline-block",
                        textAlign: "center",
                        backgroundColor: "#5460D1",
                        color: "#fff",
                        padding: "8px 16px",
                        borderRadius: "4px",
                        cursor: "not-allowed",
                        opacity: 1,
                        userSelect: "none",
                        width: "100%",
                      }}
                    >
                      Get Started
                    </span>
                    <UncontrolledTooltip placement="bottom" target={`${card.id}Nav`}>
                      Under Progress
                    </UncontrolledTooltip>
                  </>
                ) : (
                  <Button
                    color="primary"
                    className="w-100 get-started-button"
                    onClick={() => this.getStartedClicked(card.id)}
                  >
                    Get Started
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="back-link-container">
          <Button
            className="back-to-dashboard-btn"
            onClick={() => this.props.history.push("/app/dashboard")}
          >
            ← Back to Dashboard
          </Button>
        </div>

        <div className="landing-right">
          <img src={dot1} alt="Decoration" />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(BiomarkerDrugDiscoveryLanding);
